import { JSX } from "react";
import { Navigate } from "react-router";
import { useUserData } from "../../app/hooks/auth";

export const RequirePrivacyConsent = ({
  children,
}: {
  children: JSX.Element;
}) => {
  const { privacyConsentRequired } = useUserData();

  if (privacyConsentRequired) {
    return <Navigate to="/privacyConsent" replace />;
  }

  return children;
};
